import styled from '@emotion/styled';

import { unit } from '@zego/theme';

const FormActions = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  paddingTop: unit(3),
  justifyContent: 'flex-end',
});

export default FormActions;
